import { twMerge } from 'tailwind-merge'

type ClassValue = string | false | null | undefined

export function cn(...inputs: ClassValue[]) {
  return twMerge(inputs.filter(Boolean).join(' '))
}

export function surfaceClass(variant: 'card' | 'modal' = 'card') {
  const base =
    'border border-neutral-200 bg-white text-neutral-900 shadow-sm dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100'

  if (variant === 'modal') {
    return cn(base, 'shadow-xl')
  }

  return base
}

export function overlayClass() {
  return 'fixed inset-0 bg-black/40 backdrop-blur-sm'
}

export function inputClass() {
  return cn(
    'block w-full rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm text-neutral-900 shadow-sm transition-colors',
    'placeholder:text-neutral-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/40',
    'dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-100 dark:placeholder:text-neutral-500',
  )
}

export function labelClass() {
  return 'text-sm font-medium text-neutral-700 dark:text-neutral-200'
}

export function helperTextClass() {
  return 'text-xs text-neutral-500 dark:text-neutral-400'
}

export function chipClass(isActive: boolean) {
  return cn(
    'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
    isActive
      ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-200'
      : 'bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-200',
  )
}

export function iconButtonClass() {
  return cn(
    'inline-flex h-9 w-9 items-center justify-center rounded-full border border-transparent text-neutral-500 transition-colors',
    'hover:bg-neutral-100 hover:text-neutral-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2',
    'dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-neutral-100 dark:focus-visible:ring-offset-neutral-900',
  )
}
